const state = {
  isActive: false,
  currentConversationId: null,
  currentAccountId: null,
};

const getters = {
  getVideoCallState: _state => _state.isActive,
  getCurrentVideoCallConversation: _state => _state.currentConversationId,
  getCurrentVideoCallAccount: _state => _state.currentAccountId,
};

const actions = {
  startVideoCall({ commit }, { conversationId, accountId }) {
    commit('SET_VIDEO_CALL_ACTIVE', true);
    commit('SET_VIDEO_CALL_CONVERSATION', conversationId);
    commit('SET_VIDEO_CALL_ACCOUNT', accountId);
  },
  endVideoCall({ commit }) {
    commit('SET_VIDEO_CALL_ACTIVE', false);
    commit('SET_VIDEO_CALL_CONVERSATION', null);
    commit('SET_VIDEO_CALL_ACCOUNT', null);
  },
};

const mutations = {
  SET_VIDEO_CALL_ACTIVE(_state, status) {
    _state.isActive = status;
  },
  SET_VIDEO_CALL_CONVERSATION(_state, conversationId) {
    _state.currentConversationId = conversationId;
  },
  SET_VIDEO_CALL_ACCOUNT(_state, accountId) {
    _state.currentAccountId = accountId;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
